import Vue from "vue";
import Router from "vue-router";

//importing components
import Home from "@/components/Home";
import Login from "@/components/Login";

// Setari components
import Setari from "@/components/Setari/Setari";
// import SetariUsers from '@/components/Setari/SetariUsers'
// import SetariProduse from '@/components/Setari/SetariProduse'

// Cereri site components
import Cereri from "@/components/CereriSite/Cereri";
import DetaliiCerere from "@/components/CereriSite/DetaliiCerere";

// Oferte components
import Oferte from "@/components/Oferte/Oferte";
import OferteClient from "@/components/Oferte/OferteClient";
import DetaliiOferta from "@/components/Oferte/DetaliiOferta";
import AddOferta from "@/components/Oferte/AddOferte/AddOferta";
import EditOferta from "@/components/Oferte/EditOferta";

// Leads components
import Leads from "@/components/Leads/Leads"
import AddLead from "@/components/Leads/AddLead"

// Comenzi components
import Comenzi from "@/components/Comenzi/Comenzi";
import ComenziFinalizate from "@/components/Comenzi/ComenziFinalizate";
import DetaliiComanda from "@/components/Comenzi/DetaliiComanda";
import AddComanda from "@/components/Comenzi/AddComanda";
import EditComanda from "@/components/Comenzi/EditComanda";

// Clienti components
import Clienti from "@/components/Clients/Clienti";
// import AddClient from '@/components/Clients/AddClient'
import EditClient from "@/components/Clients/EditClient";
import DetaliiClient from "@/components/Clients/DetaliiClient";

// Debitare components
import Debitare from "@/components/Debitare/Debitare";
import Raport from "@/components/Debitare/Raport";
import ListaDebitari from "@/components/Debitare/ListaDebitari";
import AddDebitare from "@/components/Debitare/AddDebitare";

// import DetaliiDebitare from '@/components/Debitare/DetaliiDebitare'
// import EditDebitare from '@/components/Debitare/EditDebitare'

import Echipe from "@/components/Debitare/Echipe";
import AddEchipa from "@/components/Debitare/AddEchipa";
import EditEchipa from "@/components/Debitare/EditEchipa";

import Profile from "@/components/Debitare/Profile";
import AddProfil from "@/components/Debitare/AddProfil";
import EditProfil from "@/components/Debitare/EditProfil";

import ComenziDeb from "@/components/Debitare/ComenziDeb";
import ComenziDebFinalizate from "@/components/Debitare/ComenziDebFinalizate";
import AddComenziDeb from "@/components/Debitare/AddComenziDeb";

import Avize from "@/components/Debitare/Avize";
import DetaliiAviz from "@/components/Debitare/DetaliiAviz";

import Stocuri from "@/components/Debitare/Stocuri";
import AddProfileStoc from "@/components/Debitare/AddProfileStoc";
// import StocMateriale from '@/components/Debitare/StocMateriale'

// Productie components
import OferteProductie from "@/components/Productie/OferteProductie";
import OferteProductieGarduri from "@/components/Productie/OferteProductieGarduri";
import OferteProductieConfiguratorGard from "@/components/Productie/OferteProductieConfiguratorGard";
import ListaReveniriConfiguratorGard from "@/components/Productie/ListaReveniriConfiguratorGard";
import OferteProductieConfiguratorEU from "@/components/Productie/OferteProductieConfiguratorEU";
import ListaReveniriConfiguratorGardEU from "@/components/Productie/ListaReveniriConfiguratorGardEu";
import OferteProductieGeneral from "@/components/Productie/OferteProductieGeneral";
import OferteProductieConfiguratorNou from "@/components/Productie/OferteProductieConfiguratorNou";

import AddOfertaProductie from "@/components/Productie/AddOfertaProductie";
import DetaliiOfertaProductie from "@/components/Productie/DetaliiOfertaProductie";

// import AddMateriePrima from '@/components/Productie/AddMateriePrima'
// import EditMateriePrima from '@/components/Productie/EditMateriePrima'
import OfertaMateriePrima from "@/components/Productie/OfertaMateriePrima";

// import AddManopera from '@/components/Productie/AddManopera'
// import EditManopera from '@/components/Productie/EditManopera'
import OfertaManopera from "@/components/Productie/OfertaManopera";

// import AddVopsit from '@/components/Productie/AddVopsit'
// import EditVopsit from '@/components/Productie/EditVopsit'
import OfertaVopsit from "@/components/Productie/OfertaVopsit";

// import AddServ from '@/components/Productie/AddServ'
// import EditServ from '@/components/Productie/EditServ'
import OfertaServicii from "@/components/Productie/OfertaServicii";

// import AddConsumabil from '@/components/Productie/AddConsumabil'
// import EditConsumabil from '@/components/Productie/EditConsumabil'
import OfertaConsumabile from "@/components/Productie/OfertaConsumabile";

// import AddAlteMat from '@/components/Productie/AddAlteMat'
// import EditAlteMat from '@/components/Productie/EditAlteMat'
import OfertaMateriale from "@/components/Productie/OfertaMateriale";

import OfertaGard from "@/components/Productie/Garduri/OfertaGard";

import WorksList from "@/components/Lucrari/WorksList";
import WorkDetails from "@/components/Lucrari/WorkDetails";
import WorkCalendar from "@/components/Lucrari/WorkCalendar";

// Agenti components
import Bonus from "@/components/Agenti/Bonus";

// Proforme components
import Proforme from "@/components/Proforme/Proforme";
import ProformeProductie from "@/components/Proforme/ProformeProductie";
import ProformeProductieRo from "@/components/Proforme/ProformeProductieRO";
import ProformeProductieEu from "@/components/Proforme/ProformeProductieEU";

// Contracte components
import ContracteProductie from "@/components/Contracte/ContracteProductie";
import ContracteProductieRO from "@/components/Contracte/ContracteProductieRO";
import ContracteProductieEU from "@/components/Contracte/ContracteProductieEU";
// import ContracteProductiePartener from "@/components/Contracte/ContracteProductiePartener";
import DetaliiContractProductie from "@/components/Contracte/DetaliiContractProductie";
import AditionalContractProductie from "@/components/Contracte/AditionalContractProductie";

// Cereri boltari components
import CereriOfertaBoltari from "@/components/Productie/Constructii/CereriOfertaBoltari";

// Rapoarte
import Rapoarte from "@/components/Rapoarte/Rapoarte";

// Rapoarte productie
import RapoarteProductie from "@/components/Rapoarte/RapoarteProductie";

// Showrooms
import Showroom from "@/components/Showroom/Showroom.vue";

// Fence Materials
import FenceMaterials from "@/components/FenceMaterials/FenceMaterials.vue";

// Test new Fence Module
import FenceModule from "@/components/Fence-Module";

// Import Firebase
import firebase from "firebase/app";
import store from "../stores/store";
import { isExportOnly } from "@/utils";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: "/login",
    },
    //Home route
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        restrictTo: [],
      },
    },
    //Login route
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        restrictTo: [],
      },
    },
    //Setari route
    {
      path: "/setari",
      name: "Setari",
      component: Setari,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    // Cereri site routes
    {
      path: "/cererisite",
      name: "Cereri",
      component: Cereri,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/cererisite/single/:id",
      name: "DetaliiCerere",
      props: true,
      component: DetaliiCerere,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    // Leads routes
    {
      path: "/leads",
      name: "Leads",
      component: Leads,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"]
      }
    },
    {
      path: "/leads/add",
      name: "AddLead",
      component: AddLead,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"]
      }
    },
    // Oferte routes
    {
      path: "/oferte",
      name: "Oferte",
      component: Oferte,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/oferte/client/:id",
      name: "OferteClient",
      component: OferteClient,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/oferte/single/:id",
      name: "DetaliiOferta",
      component: DetaliiOferta,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/oferte/add/:fromWebShop",
      name: "AddOferta",
      component: AddOferta,
      props: true,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/oferte/edit/:id",
      name: "EditOferta",
      component: EditOferta,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    //Comenzi routes
    {
      path: "/comenzi",
      name: "Comenzi",
      component: Comenzi,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/comenzi/finalizate",
      name: "ComenziFinalizate",
      component: ComenziFinalizate,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/comenzi/single/:id",
      name: "DetaliiComanda",
      component: DetaliiComanda,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/comenzi/add",
      name: "AddComanda",
      component: AddComanda,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/comenzi/edit/:id",
      name: "EditComanda",
      component: EditComanda,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    //Clienti routes
    {
      path: "/clienti",
      name: "Clienti",
      component: Clienti,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/clienti/edit/:id",
      name: "EditClient",
      component: EditClient,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/clienti/single/:id",
      name: "DetaliiClient",
      component: DetaliiClient,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    //Debitare routes
    {
      path: "/debitare",
      name: "Debitare",
      component: Debitare,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/raport",
      name: "Raport",
      component: Raport,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/listadebitari",
      name: "ListaDebitari",
      component: ListaDebitari,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/add",
      name: "AddDebitare",
      component: AddDebitare,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/echipe",
      name: "Echipe",
      component: Echipe,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/echipa/add",
      name: "AddEchipa",
      component: AddEchipa,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/echipa/edit/:id",
      name: "EditEchipa",
      component: EditEchipa,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/profile",
      name: "Profile",
      component: Profile,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/profil/add",
      name: "AddProfil",
      component: AddProfil,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/profil/edit/:id",
      name: "EditProfil",
      component: EditProfil,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/comenzi",
      name: "ComenziDeb",
      component: ComenziDeb,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/comenzi/finalizate",
      name: "ComenziDebFinalizate",
      component: ComenziDebFinalizate,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/comenzi/add",
      name: "AddComenziDeb",
      component: AddComenziDeb,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/avize",
      name: "Avize",
      component: Avize,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/avize/single/:id",
      name: "DetaliiAviz",
      component: DetaliiAviz,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/stocuri",
      name: "Stocuri",
      component: Stocuri,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/debitare/stocprofile/add",
      name: "AddProfileStoc",
      component: AddProfileStoc,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    // Productie routes
    {
      path: "/oferte-productie",
      redirect: "/oferte-productie/oferte-garduri",
      name: "OferteProductie",
      component: OferteProductie,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user", "partener"],
      },
      children: [
        {
          path: "oferte-garduri",
          name: "OferteProductieGarduri",
          component: OferteProductieGarduri,
          meta: {
            restrictTo: ["admin", "superuser", "agent", "user", "partener"],
          },
        },
        {
          path: "oferte-configurator-ro",
          name: "OferteProductieConfiguratorGard",
          component: OferteProductieConfiguratorGard,
          meta: {
            restrictTo: ["admin", "superuser", "agent", "user", "partener"],
          },
          // export agents see only EU offers: the EU configurator instead
          beforeEnter: (to, from, next) => {
            if (isExportOnly(store.state.user)) return next({ path: "/oferte-productie/oferte-configurator-eu" });
            next();
          },
        },
        {
          path: "lista-reveniri-ro",
          name: "ListaReveniriConfiguratorGard",
          component: ListaReveniriConfiguratorGard,
          meta: {
            restrictTo: ["admin", "superuser", "agent", "user", "partener"],
          },
          // export agents see only EU offers: the EU configurator instead
          beforeEnter: (to, from, next) => {
            if (isExportOnly(store.state.user)) return next({ path: "/oferte-productie/oferte-configurator-eu" });
            next();
          },
        },
        {
          path: "oferte-configurator-eu",
          name: "OferteProductieConfiguratorEU",
          component: OferteProductieConfiguratorEU,
          meta: {
            restrictTo: ["admin", "superuser", "agent", "user"],
          },
        },
        {
          path: "lista-reveniri-eu",
          name: "ListaReveniriConfiguratorGardEU",
          component: ListaReveniriConfiguratorGardEU,
          meta: {
            restrictTo: ["admin", "superuser", "agent", "user"],
          },
        },
        {
          path: "oferte-general",
          name: "OferteProductieGeneral",
          component: OferteProductieGeneral,
          meta: {
            restrictTo: ["admin", "superuser", "agent", "user"],
          },
        },
        {
          path: "oferte-configurator-nou",
          name: "OferteProductieConfiguratorNou",
          component: OferteProductieConfiguratorNou,
          meta: {
            restrictTo: ["admin", "superuser", "agent", "user", "partener"],
          },
        },
      ],
    },
    {
      path: "/oferte-productie/add",
      name: "AddOfertaProductie",
      component: AddOfertaProductie,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user", "partener"],
      },
    },
    {
      path: "/oferte-productie/single/:id",
      name: "DetaliiOfertaProductie",
      component: DetaliiOfertaProductie,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user", "partener"],
      },
    },
    {
      path: "/oferte-productie/materieprima/:id",
      name: "OfertaMateriePrima",
      component: OfertaMateriePrima,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/oferte-productie/manopera/:id",
      name: "OfertaManopera",
      component: OfertaManopera,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/oferte-productie/vopsit/:id",
      name: "OfertaVopsit",
      component: OfertaVopsit,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/oferte-productie/servicii/:id",
      name: "OfertaServicii",
      component: OfertaServicii,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/oferte-productie/consumabile/:id",
      name: "OfertaConsumabile",
      component: OfertaConsumabile,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/oferte-productie/materiale/:id",
      name: "OfertaMateriale",
      component: OfertaMateriale,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user", "partener"],
      },
    },
    {
      path: "/oferte-productie/gard/:id",
      name: "OfertaGard",
      component: OfertaGard,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user", "partener"],
      },
    },
    // Lucrari routes
    {
      path: "/lucrari",
      name: "WorksList",
      component: WorksList,
      meta: {
        restrictTo: ["admin", "superuser", "user", "agent"],
      },
    },
    {
      path: "/lucrari/:id(\\d+)",
      name: "WorkDetails",
      component: WorkDetails,
      meta: {
        restrictTo: ["admin", "superuser", "user", "agent"],
      },
    },
    {
      path: "/lucrari/calendar/:type(masuratori|productie|montaj)",
      name: "WorkCalendar",
      component: WorkCalendar,
      props: true,
      meta: {
        restrictTo: ["admin", "superuser", "user", "agent"],
      },
    },
    // Old Lucrari productie links
    { path: "/lucrari-productie", redirect: "/lucrari" },
    { path: "/lucrari-productie/single/:id", redirect: "/lucrari" },
    { path: "/calendar-productie", redirect: "/lucrari/calendar/productie" },
    // Agenti routes
    {
      path: "/agenti/bonus",
      name: "Bonus",
      component: Bonus,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    // Proforme routes
    {
      path: "/proforme",
      name: "Proforme",
      component: Proforme,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
    },
    {
      path: "/productie/proforme",
      redirect: "/productie/proforme/ro",
      name: "ProformeProductie",
      component: ProformeProductie,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user"],
      },
      children: [
        {
          path: "ro",
          name: "ProformeProductieRo",
          component: ProformeProductieRo,
          meta: {
            restrictTo: ["admin", "superuser", "agent", "user"],
          },
          // export agents see only EU proformas
          beforeEnter: (to, from, next) => {
            if (isExportOnly(store.state.user)) return next({ path: "/productie/proforme/eu" });
            next();
          },
        },
        {
          path: "eu",
          name: "ProformeProductieEu",
          component: ProformeProductieEu,
          meta: {
            restrictTo: ["admin", "superuser", "agent", "user"],
          },
        },
      ]
    },
    // Contracte routes
    {
      path: "/productie/contracte",
      redirect: "/productie/contracte/ro",
      name: "ContracteProductie",
      component: ContracteProductie,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user", "partener"],
      },
      children: [
        {
          path: "ro",
          name: "ContracteProductieRO",
          component: ContracteProductieRO,
          meta: {
            restrictTo: ["admin", "superuser", "agent", "user"],
          },
          // export agents see only EU contracts
          beforeEnter: (to, from, next) => {
            if (isExportOnly(store.state.user)) return next({ path: "/productie/contracte/eu" });
            next();
          },
        },
        {
          path: "eu",
          name: "ContracteProductieEU",
          component: ContracteProductieEU,
          meta: {
            restrictTo: ["admin", "superuser", "agent", "user"],
          },
        },
        // {
        //   path: "partener",
        //   name: "ContracteProductiePartener",
        //   component: ContracteProductiePartener,
        //   meta: {
        //     restrictTo: ["admin", "superuser", "partener"],
        //   },
        // },
      ]
    },
    {
      path: "/productie/contracte/single/:id",
      name: "DetaliiContractProductie",
      component: DetaliiContractProductie,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user", "partener"],
      },
    },
    {
      path: "/productie/contracte/single/:id/aditional/:idAditional",
      name: "AditionalContractProductie",
      component: AditionalContractProductie,
      meta: {
        restrictTo: ["admin", "superuser", "agent", "user", "partener"],
      },
    },
    // Productie - construction (boltari) routes
    {
      path: "/productie/oferte-gard/constructii",
      name: "CereriOfertaBoltari",
      component: CereriOfertaBoltari,
      meta: {
        restrictTo: ["admin", "superuser", "colaborator"],
      },
    },
    // Rapoarte
    {
      path: "/rapoarte/",
      name: "Rapoarte",
      component: Rapoarte,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    {
      path: "/productie/rapoarte/",
      name: "RapoarteProductie",
      component: RapoarteProductie,
      meta: {
        restrictTo: ["admin", "superuser"],
      },
    },
    // Showroom
    {
      path: "/productie/showroom",
      name: "Showroom",
      component: Showroom,
      meta: {
        restrictTo: ["admin", "superuser", "user", "agent"],
      }
    },
    // Fence Materials Bill
    {
      path: "/kit-gard/materiale/:id",
      name: "FenceMaterials",
      component: FenceMaterials,
      props: true,
      meta: {
        restrictTo: ["admin"],
      },
    },
    // Tests
    {
      path: "/tests/",
      name: "Tests",
      component: FenceModule,
      meta: {
        restrictTo: ["admin"],
      },
    },
  ],
});

// Nav Guards
router.beforeEach(async (to, from, next) => {
  const authUser = firebase.auth().currentUser;

  // If user is not authenticated, send to login and remember where he wanted to go
  if (!authUser) {
    if (to.name === "Login") return next();
    return next({ path: "/login", query: { redirect: to.fullPath } });
  }

  // Already logged in, so skip login page
  if (to.name === "Login") {
    return next({ path: to.query.redirect || "/" });
  }

  // On a direct page load the user role is not in the store yet, so wait for it
  if (!store.state.userLoaded) {
    await store.dispatch("fetchUser", authUser.email);
  }

  const { restrictTo = [] } = to.meta;
  if (restrictTo.length > 0 && !restrictTo.includes(store.state.user.rol)) {
    // role not authorised so redirect to home page
    return next({ path: "/" });
  }
  next();
});

export default router;
